/** Shared money formatting for the finance calculators. */
export const CURRENCY_CHOICES = [
  { code: "USD", label: "$ US dollar" }, { code: "EUR", label: "€ Euro" }, { code: "GBP", label: "£ Pound" }, { code: "INR", label: "₹ Rupee" },
  { code: "CAD", label: "C$ Canadian dollar" }, { code: "AUD", label: "A$ Australian dollar" }, { code: "JPY", label: "¥ Yen" },
  { code: "SGD", label: "S$ Singapore dollar" }, { code: "AED", label: "AED Dirham" }, { code: "ZAR", label: "R Rand" },
];

/** Minor-unit digits of a currency (JPY 0, USD 2, KWD 3). Falls back to 2. */
export function currencyDigits(currency: string): number {
  try { return new Intl.NumberFormat("en-US", { style: "currency", currency }).resolvedOptions().maximumFractionDigits ?? 2; } catch { return 2; }
}

export function fmtMoney(n: number, currency = "USD", decimals: number = currencyDigits(currency)): string {
  if (!Number.isFinite(n)) return "—";
  const locale = currency === "INR" ? "en-IN" : "en-US";
  try {
    return new Intl.NumberFormat(locale, { style: "currency", currency, minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(n);
  } catch {
    return n.toFixed(decimals);
  }
}
